import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';
import { SelfOnboardingServiceModel } from '@savgroup-front-common/types/Onboarding/ServiceModel';

const ENDPOINT = `${APIConfiguration.repairer}selfonboarding/service`;

interface UpsertSelfOnboardingServiceCommandPayload {
  sellerId?: string;
  service: SelfOnboardingServiceModel;
}

async function upsertSelfOnboardingServiceCommand({
  sellerId,
  service,
}: UpsertSelfOnboardingServiceCommandPayload): Promise<
  BaseBackResponse | BackResponseFailure
> {
  try {
    const response = await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        sellerId,
        ...service,
      },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default upsertSelfOnboardingServiceCommand;
